<div [attr.data-automation]="dataAutomation()" class="row">
  <div class="col-12 col-md-6">
    <ziro-radio [fieldId]="'greetings'"></ziro-radio>
  </div>

  <div class="col-12 col-md-6">
    <div [hidden]="formData.greetings !== CallFlowGreetingsOptions.CUSTOM_GREETING">
      <ziro-file-upload [fieldId]="'greetingUpload'" [inlineLabel]="false"></ziro-file-upload>
      @if (!isGreetingLoading() && greetingUploadURL() && acceptedFileTypes.includes(greetingFileExtension())) {
        <audio
          [attr.data-automation]="'greeting-audio'"
          class="mt-2 w-100"
          controls
          [src]="greetingUploadURL()"
          [title]="greetingDownloadName()"
        ></audio>
      }
    </div>

    <ziro-textarea
      [fieldId]="'greetingTtsMessage'"
      [hidden]="formData.greetings !== CallFlowGreetingsOptions.TTS_MESSAGE"
    ></ziro-textarea>
  </div>
</div>
